module.exports = __webpack_public_path__ + "static/media/logo.e54eea63.png";